/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Meta_Description1Inputs */

const ja_playdata_eventreport_meta_description1 = /** @type {(inputs: Playdata_Eventreport_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指定したeスポーツ大会の詳細分析をPDFレポートとして生成できます。`)
};

const en_playdata_eventreport_meta_description1 = /** @type {(inputs: Playdata_Eventreport_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detailed PDF analysis of any Japanese esports event, including concurrent viewers and competitive comparison.`)
};

/**
* | output |
* | --- |
* | "Detailed PDF analysis of any Japanese esports event, including concurrent viewers and competitive comparison." |
*
* @param {Playdata_Eventreport_Meta_Description1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_meta_description1 = /** @type {((inputs?: Playdata_Eventreport_Meta_Description1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Meta_Description1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_meta_description1(inputs)
	return en_playdata_eventreport_meta_description1(inputs)
});
export { playdata_eventreport_meta_description1 as "playdata_eventReport_meta_description" }